import { Loader as GoogleApiLoader } from '@googlemaps/js-api-loader';

export const createGoogleClient = async () => {
  const googleApiLoader = new GoogleApiLoader({
    apiKey: process.env.GOOGLE_MAPS_API_KEY as string,
    libraries: ['places'],
  });

  const places = await googleApiLoader.importLibrary('places');
  const geocoding = await googleApiLoader.importLibrary('geocoding');

  return {
    autocomplete: new places.AutocompleteService(),
    geoCoder: new geocoding.Geocoder(),
    places: new places.PlacesService(document.createElement('div')),
    sessionToken: new places.AutocompleteSessionToken(),
  };
};

export const googleClient = createGoogleClient();
